import { Colors } from '../../consts/Colors';
import RoundedButton2 from '../RoundedButton2';
import Card2 from './Card2';
import { CartesInfos, TextContents } from '../../consts/DataGame2';
import DragManager from '../DragManager';

// Création du deck de jeu pour la partie 1

export default class Deck2 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, w, h) {
        super(scene, x, y, []);
        scene.add.existing(this);

        this.scene = scene;
        this.num = 1
        this.currentCardNumber = 0

        this.dragManager = new DragManager(this.scene);
        this.rect = this.scene.add.rexRoundRectangle(0, 0, w, h, 26, Colors.Elmt.Blue).setOrigin(0.5);
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.add(this.rect);

        this.repLogo = this.scene.add.image(-125, -190, 'goodAnswer').setOrigin(0.5);
        this.add(this.repLogo);
        this.repLogo.setAlpha(0)

        this.repTextGood = this.scene.add.text(-92, -190, "BRAVO", {
            font: "40px MassiliaBold",
            color: Colors.Text.Green
        }).setOrigin(0, 0.5)
        this.add(this.repTextGood)
        this.repTextGood.setAlpha(0)

        this.repTextWrong = this.scene.add.text(-92, -208, "MAUVAISE\nRÉPONSE", {
            font: "40px MassiliaBold",
            color: Colors.Text.Red,
            align: "left"
        }).setOrigin(0, 0)
        this.add(this.repTextWrong)
        this.repTextWrong.setAlpha(0)

        this.cardFeedBack = this.scene.add.text(-146, this.repTextGood.y + this.repTextGood.height + 40, "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.", {
            font: "22px MassiliaRegular",
            color: Colors.Text.Blue,
            align: "left",
            lineSpacing: 5,
            wordWrap: { width: 290, useAdvancedWrap: true }
        }).setOrigin(0, 0)
        this.add(this.cardFeedBack)
        this.cardFeedBack.setAlpha(0)

        
        // this.scene.game.data.score.mauvais++

        this.rectLabel = this.scene.add.rexRoundRectangle(0, this.rect.height / 2, 336, 88, {
            tl: 0,
            tr: 0,
            bl: 26,
            br: 26
        }, Colors.Elmt.DarkBlue).setOrigin(0.5, 1);
        this.add(this.rectLabel);

        this.numText = this.scene.add.text(145, this.rectLabel.y - 44, this.num + "/" + CartesInfos.length, {
            font: "20px MassiliaExtraLight",
            color: Colors.Text.Blue
        }).setOrigin(1, 0.5)
        this.add(this.numText)

        this.labelName = this.scene.add.text(-144, this.rectLabel.y - 44, 'Stock à vendre', {
            font: "24px MassiliaExtraBold",
            color: Colors.Text.Blue,
            wordWrap: { width: 249, useAdvancedWrap: true }
        }).setOrigin(0, 0.5)
        this.add(this.labelName)


        this.title = this.scene.createTextElement(-171, -474, TextContents.title)
        this.subtitle = this.scene.createTextElement(-171, this.title.y + this.title.height + 16, TextContents.subtitle)
        this.consigne = this.scene.createTextElement(-167, 352, TextContents.consigne)
        this.add(this.title)
        this.add(this.subtitle)
        this.add(this.consigne)
    }

    setDeckAction(cardData) {
        this.cardData = cardData
        this.card = new Card2(this.scene, 0, 30, this.cardData, this);
        this.add(this.card);
        this.dragManager.addDraggable(this.card);
        this.hideDeckInfos();
    }
    hideDeckInfos(){
        this.repLogo.setAlpha(0)
        this.repTextGood.setAlpha(0)
        this.repTextWrong.setAlpha(0)
        // this.cardFeedBackWrong.setAlpha(0)
        this.cardFeedBack.setAlpha(0)

        this.labelName.setText(this.cardData.titre)
        this.rect.fillColor = Colors.Elmt.Blue
        this.rect.setStrokeStyle(2, Colors.Elmt.White, 1);
        this.rectLabel.fillColor = Colors.Elmt.White
        this.numText.setColor(Colors.Text.Blue)
        this.labelName.setColor(Colors.Text.Blue)
        this.num = this.currentCardNumber + 1
        this.numText.setText(this.num + "/" + CartesInfos.length)
        this.rectLabel.setAlpha(0)
        this.numText.setAlpha(1)
        this.labelName.setAlpha(1)
    }

    setDeckTrue(content) {
        this.hideDeckInfos()
        this.repLogo.setAlpha(1)
        this.repLogo.setTexture('goodAnswer')
        this.repLogo.y = -190
        this.repTextGood.setAlpha(1)
        this.cardFeedBack.setAlpha(1)
        this.cardFeedBack.y = this.repTextGood.y + this.repTextGood.height/2 + 15
        this.cardFeedBack.setText(content)
        this.addNextButton(() => {
            this.card.setNormal()
            this.nextStep()
        }, "Suivant", true)
        this.rect.fillColor = Colors.Elmt.White
        this.rect.setStrokeStyle(2, Colors.Elmt.Green, 1);
        this.rectLabel.fillColor = Colors.Elmt.Green
        this.numText.setColor(Colors.Text.White)
        this.labelName.setColor(Colors.Text.White)
        this.numText.setAlpha(1)
        this.rectLabel.setAlpha(1)
        this.labelName.setAlpha(1)
    }

    setDeckFalse(content) {
        this.hideDeckInfos()
        this.repLogo.setAlpha(1)
        this.repLogo.setTexture('badAnswer')
        this.repTextWrong.text = content[0]
        this.repLogo.y = this.repTextWrong.y + this.repTextWrong.height / 2
        this.repTextWrong.setAlpha(1)
        this.cardFeedBack.setAlpha(1)
        this.cardFeedBack.setText(content[1])
        this.cardFeedBack.y = this.repTextWrong.y + this.repTextWrong.height + 15
        this.addNextButton(() => {
            this.card.resetPosition(this.card.scaleInit);
            this.card.setInteractive({ useHandCursor: true });
            this.hideDeckInfos()
        }, "Réessayer", false)
        this.rect.fillColor = Colors.Elmt.White
        this.rect.setStrokeStyle(2, Colors.Elmt.Red, 1);
        this.numText.setAlpha(0)
        this.rectLabel.setAlpha(0)
        this.labelName.setAlpha(0)

    }

    addNextButton(clickFunc, buttonText, isTrue){
        this.nextBtn = new RoundedButton2(this.scene, 0, this.rectLabel.y - 60 , 200, buttonText);

        if(this.cardFeedBack.y + this.cardFeedBack.height + 40 > this.nextBtn.y){
            this.nextBtn.y = this.cardFeedBack.y + this.cardFeedBack.height + 30
        }
        if(isTrue){
            this.nextBtn.y = 120
        }

        this.add(this.nextBtn);
        this.nextBtn.setClickFunction(() => {
            clickFunc()
            this.nextBtn.destroy()
        })
    }

    nextStep(){
        this.currentCardNumber++
        if (this.num === CartesInfos.length ) {
            this.scene.launchEndPopup()
        } else {
            this.scene.resetDropZones()
            this.setDeckAction(CartesInfos[this.currentCardNumber])
        }
    }
}